import { formatAddress } from "@common/lib/format";
import { joinDefined } from "@common/lib/misc";
import { Users } from "./types";

export const mapUser = (user: Users.Api.User): Users.User => ({
  ...user,
  addressLine: formatAddress(user),
  name: getUserDisplayName(user)
});

export const getUserDisplayName = (data: {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  userEmail?: string | null;
  userFirstName?: string | null;
  userLastName?: string | null;
  triggerUserFirstName?: string | null;
  triggerUserLastName?: string | null;
}): string => {
  return (
    joinDefined(
      " ",
      data.firstName ?? data.userFirstName ?? data.triggerUserFirstName,
      data.lastName ?? data.userLastName ?? data.triggerUserLastName
    ) ||
    (data.email ?? data.userEmail) ||
    ""
  );
};
